import React, { useEffect } from "react";
import UsePanel from "./UserPanel";
import OrderStatus from "./OrderStatus";
import Notifications from "./Notifications";
import SocialSource from "./SocialSource";
import OverView from "./OverView";
import RevenueByLocation from "./RevenueByLocation";
import LatestTransation from "./LatestTransation";

import { Row, Container } from "reactstrap";

//Import Breadcrumb
import Breadcrumbs from "../../components/Common/Breadcrumb";
import { useSelector } from "react-redux";
import axios from "axios";
import config from "../../config";
import { useCookies } from "react-cookie";

const Dashboard = () => {
  document.title = "Dashboard";

  const [cookie, setCookie] = useCookies(['_csrf_token'])

  const { menuActivedId, profile } = useSelector(state => ({
    menuActivedId: state.Layout.menuActived.id,
    profile: state.login.profile
  }))

  const getSubmenus = async () => {
    try {
      let response = await axios.post(`${config.URL_SERVER}/execute-procedure`, {
        requestData: {
          1: menuActivedId,
          2: profile?.ID_Usuario
        },
        proc: 'FRONT_Framework_Obter_Menu_Transacoes'
      },{
        headers: {
          "X-CSRF-Token": cookie?._csrf_token
        }
      });

    } catch (error) {
      console.log("Erro to load submenus")
      console.log(error)
    }
  }

  useEffect(() => {
    if(menuActivedId) getSubmenus()
  }, [menuActivedId]);

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid={true}>
          <Breadcrumbs title="Upzet" breadcrumbItem="Dashboard" />
          {/* User Panel Charts */}
          <UsePanel />

          <Row>
            {/* Overview Chart */}
            <OverView />
            {/* Social Source Chart */}
            <SocialSource />
          </Row>

          <Row>
            {/* Order Stats */}
            <OrderStatus />
            {/* Notifications */}
            <Notifications />
            {/* Revenue by Location Vector Map */}
            <RevenueByLocation />
          </Row>

          {/* Latest Transaction Table */}
          <LatestTransation />
        </Container>
      </div>
    </React.Fragment>
  );
};

export default Dashboard;
